import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=7123c59c&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=7123c59c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports